import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const WidgetArticlesContainer = styled.div`\
background-color: ${p => p.theme.bgColor};

    ${cssMediaQueryBreakpoints.medium} {
        padding-right: 20px;
        padding-left: 10px;
    }

    padding-right: 25px;
    padding-left: 15px;
    padding-bottom: 10px;
`
